import moment from 'moment-timezone';

const getOffsetMinutes = (coreUITimeZones, currentTimeZoneValue, newTimeZoneValue) => {
    const currentTimeZone = coreUITimeZones.find(tz => { return tz.id === parseInt(currentTimeZoneValue); });
    const newTimeZone = coreUITimeZones.find(tz => { return tz.id === parseInt(newTimeZoneValue); });
    const currentOffset = moment.tz(currentTimeZone.value).utcOffset();
    const newOffset = moment.tz(newTimeZone.value).utcOffset();
    return currentOffset - newOffset;
};

export const updateDivisionSpecificDatesAfterTimeZoneUpdate = (formApi, coreUITimeZones, newTimeZoneValue) => {
    const { values } = formApi;
    const { eventDivisions, eventSchedule } = values;

    const currentTimeZoneValue = eventSchedule?.timeZone;

    if (currentTimeZoneValue && newTimeZoneValue && eventDivisions?.length > 0) {
        const offSetDifference = getOffsetMinutes(coreUITimeZones, currentTimeZoneValue, newTimeZoneValue);

        eventDivisions.forEach((division, i) => {
            if (division.specificDivisionDateEnabled) {
                const newDate = moment
                    .utc(division.specificDivisionDateUtc)
                    .add(offSetDifference, 'minutes');
                formApi.setValue(['eventDivisions', i, 'specificDivisionDateUtc'], newDate.toISOString());
            }
        });
    }
};

export const updateEventScheduleDatesAfterTimeZoneUpdate = (formApi, coreUITimeZones, newTimeZoneValue) => {
    const { values } = formApi;
    const { eventSchedule } = values;

    const currentTimeZoneValue = eventSchedule?.timeZone;
    if (currentTimeZoneValue && newTimeZoneValue && eventSchedule) {
        const offSetDifference = getOffsetMinutes(coreUITimeZones, currentTimeZoneValue, newTimeZoneValue);

        const valuesToCheckANdEdit = [
            'eventStartUtc',
            'eventEndUtc',
            'registrationStartUtc',
            'registrationEndUtc',
            'drawPublishedUtc',
        ];
        valuesToCheckANdEdit.forEach((key) => {
            const dateValue = eventSchedule[key];
            if (dateValue) {
                const newDate = moment
                    .utc(dateValue)
                    .add(offSetDifference, 'minutes');
                formApi.setValue(['eventSchedule', key], newDate.toISOString());
            }
        });

        if (values?.recurrenceSettings?.endsOnDate) {
            const newDate = moment
                .utc(values.recurrenceSettings.endsOnDate)
                .add(offSetDifference, 'minutes');
            formApi.setValue(['recurrenceSettings', 'endsOnDate'], newDate.toISOString());
        }

        if (Array.isArray(values?.recurrenceSettings?.recurrentEvents)) {
            values.recurrenceSettings.recurrentEvents.forEach((recurrentEvent, index) => {
                [
                    ['startDate', 'startDate'],
                    ['endDate', 'endDate'],
                    ['registrationStartDate', 'registrationStartDate'],
                    ['registrationEndDate', 'registrationEndDate'],
                ].forEach(([fieldKey, pathKey]) => {
                    const overrideValue = recurrentEvent[fieldKey];
                    if (overrideValue) {
                        const newDate = moment
                            .utc(overrideValue)
                            .add(offSetDifference, 'minutes');
                        formApi.setValue(['recurrenceSettings', 'recurrentEvents', index, pathKey], newDate.toISOString());
                    }
                });
            });
        }

        if (Array.isArray(values?.recurrenceSettings?.exceptions)) {
            values.recurrenceSettings.exceptions.forEach((exception, index) => {
                if (exception?.overrides) {
                    ['eventStartUtc', 'eventEndUtc', 'registrationStartUtc', 'registrationEndUtc'].forEach((key) => {
                        const overrideValue = exception.overrides[key];
                        if (overrideValue) {
                            const newDate = moment
                                .utc(overrideValue)
                                .add(offSetDifference, 'minutes');
                            formApi.setValue(['recurrenceSettings', 'exceptions', index, 'overrides', key], newDate.toISOString());
                        }
                    });
                }
            });
        }
    }
};
